export const version = "transactions/5.6.0";
//# sourceMappingURL=_version.js.map